import { InputDataTypeMaxMin } from '../types/ViewModel/InputDataTypeMaxMin';
import { InputDataTypeMaxMinBM } from '../types/BusinessModel/InputDataTypeMaxMinBM';

export class InputDataTypeMaxMinFactory {
    public newInputDataTypeMaxMin(inputDataTypeMaxMin: InputDataTypeMaxMinBM): InputDataTypeMaxMin {
        return new InputDataTypeMaxMin(
            inputDataTypeMaxMin.inputDataTypeMaxMinId,
            inputDataTypeMaxMin.dataTypeIntMax,
            inputDataTypeMaxMin.dataTypeIntMin,
            inputDataTypeMaxMin.dataTypeDecimalMax,
            inputDataTypeMaxMin.dataTypeDecimalMin,
            inputDataTypeMaxMin.dataTypeDurationMax,
            inputDataTypeMaxMin.dataTypeDurationMaxDescription,
            inputDataTypeMaxMin.dataTypeDurationMin,
            inputDataTypeMaxMin.dataTypeDurationMinDescription
        );
    }

    public createInputDataTypeMaxMin(inputDataTypeMaxMin: InputDataTypeMaxMin | null): InputDataTypeMaxMin | null {
        if (inputDataTypeMaxMin) {
            return new InputDataTypeMaxMin(
                inputDataTypeMaxMin.inputDataTypeMaxMinId,
                inputDataTypeMaxMin.dataTypeIntMax,
                inputDataTypeMaxMin.dataTypeIntMin,
                inputDataTypeMaxMin.dataTypeDecimalMax,
                inputDataTypeMaxMin.dataTypeDecimalMin,
                inputDataTypeMaxMin.dataTypeDurationMax,
                inputDataTypeMaxMin.dataTypeDurationMaxDescription,
                inputDataTypeMaxMin.dataTypeDurationMin,
                inputDataTypeMaxMin.dataTypeDurationMinDescription
            );
        }
        return null;
    }
}
